import React from 'react';
import { Modal, Button } from 'react-bootstrap';

import WarningPopupImg from '../../assets/images/svg/warning_popup.svg';
import ErrorPopupImg from '../../assets/images/svg/error_popup.svg';
import SuccessPopupImg from '../../assets/images/svg/success_popup.svg';

const iconMap = {
  warning: WarningPopupImg,
  error: ErrorPopupImg,
  success: SuccessPopupImg
};

const CommonAlertPopup = ({
  show,
  onClose,
  onConfirm,
  type = 'warning',
  title = 'Alert',
  message = '',
  confirmText = 'Yes',
  cancelText = 'No',
  isConfirm = true,
  isCancel = true,
  form = false,
  moreWidth = false
}) => {
  const imageSrc = iconMap[type] || WarningPopupImg;

  return (
    <Modal
      size="md"
      show={show}
      onHide={onClose}
      backdrop="static"
      keyboard={false}
      centered
      className={`common-popup-wrapper ${type} ${moreWidth ? 'more-width' : ''}`}>
      <Modal.Header className="popup-image-wrapper">
        <Modal.Title>
          <img src={`admin/${imageSrc}`} alt={type} />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="popup-title">{title}</div>
        {form ? (
          <div className="">{message}</div>
        ) : (
          <div className="popup-text" dangerouslySetInnerHTML={{ __html: message }} />
        )}
      </Modal.Body>
      {isConfirm || isCancel ? (
        <Modal.Footer className="popup-btns">
          {isConfirm && <Button onClick={onConfirm}>{confirmText}</Button>}
          {isCancel && (
            <Button className="cancle-btn" onClick={onClose}>
              {cancelText}
            </Button>
          )}
        </Modal.Footer>
      ) : null}
    </Modal>
  );
};

export default CommonAlertPopup;
